export enum ExperienceTypeForBasket {
  'spa-treatment' = 'spa-treatments',
  'spa-day' = 'spa-days',
  'spa-facility' = 'spa-facilities',
  'spa-class' = 'spa-classes',
}
